import { render, staticRenderFns } from "./DSRefreshIcon.vue?vue&type=template&id=4ba78410&scoped=true&"
import script from "./DSRefreshIcon.vue?vue&type=script&lang=js&"
export * from "./DSRefreshIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba78410",
  null
  
)

export default component.exports